import { api } from "@api/api";
import { PartnerReferral } from "@modules/partners/types";
import { ReferralFormValues } from "@modules/partners/validations";

export async function editReferralService(
  id: number | string,
  data: Partial<ReferralFormValues>
): Promise<PartnerReferral> {
  const { data: referral } = await api.patch<PartnerReferral>(
    `/v1/partner_referral_admin/${id}/`,
    data
  );
  return referral;
}
